/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-inferrable-types */
import moment from 'moment'
import axios, { CancelTokenSource } from 'axios'
import {
  PrestationApiResults,
  DossierApiResults,
} from 'utils/__interfaces/MyDemands/myDemands'
import OrganizationEntity from 'utils/__interfaces/Administrations/Organizations/OrganizationEntity'
import InstitutionEntity from 'utils/__interfaces/Perimeter/InstitutionEntity'
import DemandNormalizer from 'normalizer/DemandNormalizer'
import {
  DemandEntity,
  DemandDetailEntity,
  MotifTransco,
  IFilePostResponse,
  ICommentPostResponse,
  DemandStatusOptions,
  DemandTranscoECE,
  DemandCategory,
  DemandMotif,
} from 'utils/__interfaces/MyDemands/DemandEntity'
import DemandDetailNormalizer from 'normalizer/DemandDetailNormalizer'
import { formatToInputDateWDH } from 'utils/Common/date-utils'
import { convertMotifFromEceToCcap } from 'utils/MyDemands/myDemands'
import { TIME_OUT_TABLE } from 'utils/__consts/Common/Table'
import isCancel from 'utils/Common/api-utils'
import { getMemberData, getTotalItems } from './hydra-services'

let cancelToken: CancelTokenSource
let cancelTokenAdresse: CancelTokenSource
let cancelTokenProgress: CancelTokenSource

export async function getListTransco(
  categoryCode?: string | null
): Promise<DemandTranscoECE[]> {
  let url = `${process.env.REACT_APP_BASE_API_URL}/demand_transcodifications?actif=1`

  if (categoryCode) {
    url += `&demandCategory.code=${categoryCode}`
  }
  let listTransco
  try {
    const resp = await axios({
      method: 'GET',
      url,
    })

    const responseData = getMemberData(resp?.data)
    listTransco = DemandNormalizer.normalizeTransco(responseData)
  } catch (err) {
    console.error(err)
    throw new Error(
      `Erreur lors de l'appel de l'api getTranscodificationMotifs`
    )
  }
  return listTransco
}

export async function getEceCategories(): Promise<DemandCategory[]> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/demand_categories`

  let listCategories = []
  try {
    const resp = await axios({
      method: 'GET',
      url,
    })

    listCategories = getMemberData(resp?.data)
  } catch (err) {
    console.error(err)
    throw new Error(`Erreur lors de l'appel de l'api get demand_categories`)
  }
  return listCategories
}

export async function getEceMotifs(): Promise<DemandMotif[]> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/demand_motifs`

  let listMoties = []
  try {
    const resp = await axios({
      method: 'GET',
      url,
    })

    listMoties = getMemberData(resp?.data)
  } catch (err) {
    console.error(err)
    throw new Error(`Erreur lors de l'appel de l'api get demand_motifs`)
  }
  return listMoties
}

export async function getAdresses(
  organisation: OrganizationEntity[],
  institution: InstitutionEntity[],
  searchAdresse?: string,
  type?: string
): Promise<PrestationApiResults> {
  const url = `${process.env.REACT_APP_BASE_API_WDH_URL}/adresses`

  const params = new URLSearchParams()

  if (searchAdresse) params.append('searchAdresse', searchAdresse)

  if (type) params.append('typeAdresse', type)

  organisation.forEach((org) => {
    params.append(`idOrganisation[]`, org.id)
  })
  institution.forEach((insti) => {
    params.append(`fkentreprise[]`, insti.id)
  })
  params.append('perPage', '100')

  if (cancelTokenAdresse !== undefined) {
    cancelTokenAdresse.cancel('Operation cancelled due to new request.')
  }

  cancelTokenAdresse = axios.CancelToken.source()

  try {
    const resp = await axios({
      method: 'GET',
      url,
      params,
      cancelToken: cancelTokenAdresse.token,
    })
    const data = getMemberData(resp?.data)
    return {
      count: data.length,
      data,
    }
  } catch (err) {
    if (isCancel(err)) {
      return Promise.resolve(err)
    }
    throw new Error("Erreur lors de l'appel de l'api adresses")
  }
}

export async function getServiceSouscrits(
  organisation: OrganizationEntity[],
  institution: InstitutionEntity[],
  idsAdresse: string[],
  searchDossier?: string
): Promise<DossierApiResults> {
  const url = `${process.env.REACT_APP_BASE_API_WDH_URL}/service_souscrits`

  const params = new URLSearchParams()

  if (searchDossier) {
    params.append('searchDossier', searchDossier)
  }

  organisation.forEach((org) => {
    params.append(`idOrganisation[]`, org.id)
  })
  institution.forEach((insti) => {
    params.append(`idEtablissement[]`, insti.id)
  })
  idsAdresse.forEach((idAdresse) => {
    params.append('idAdresse[]', idAdresse)
  })

  params.append('perPage', '100')

  if (cancelToken !== undefined) {
    cancelToken.cancel('Operation cancelled due to new request.')
  }

  cancelToken = axios.CancelToken.source()

  try {
    const resp = await axios({
      method: 'GET',
      url,
      params,
      cancelToken: cancelToken.token,
    })

    const data = getMemberData(resp?.data)
    return {
      count: data.length,
      data,
    }
  } catch (err) {
    console.error(err)
    if (isCancel(err)) {
      return Promise.resolve(err)
    }
    throw new Error(`Erreur lors de l'appel de l'api services souscrits`)
  }
}

export async function createDemand(formData: FormData): Promise<string> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/demands/request`
  try {
    const resp = await axios({
      method: 'POST',
      url,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return resp?.data?.id
  } catch (err) {
    console.error(err)
    throw new Error(`Erreur lors de l'appel de l'api de création d'une demande`)
  }
}
export async function createDemandApply(id: string): Promise<number> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/demands/apply/${id}`
  const resp = await axios({
    method: 'POST',
    url,
  })

  return resp?.status
}

export function formatDataDemandDevis(values: any) {
  let siteType = ''
  let etsPresteAdresse = ''
  let etsPresteCode = ''
  let etsPresteVille = ''
  let numDebiteurBenif = ''
  let idEtablissementBenif = ''
  const planifiedDate = moment(values.planifiedDate)?.format(
    'YYYY-MM-DD HH:mm:ss'
  )
  // Add autre to waste type and convert the array into a string, with elements separated by ";"
  let dechetsTypeWithAutre = [...values.dechetsType]
  if (values.autreDechet.trim() !== '') {
    dechetsTypeWithAutre = dechetsTypeWithAutre.filter(
      (item) => item !== 'Autres'
    )
    dechetsTypeWithAutre.push(values.autreDechet.trim())
  }
  let typeWaste = dechetsTypeWithAutre.filter(Boolean).join('; ')
  typeWaste =
    typeWaste !== ''
      ? `Collecte du(des) déchet(s) suivant(s) : ${typeWaste}`
      : ''

  const nbrSites =
    values.numberOfSites > 1
      ? 'adresses sont concernées par ma demande'
      : 'adresse est concernée par ma demande'
  const doYouHave =
    values.besoinType === 'Ne sait pas'
      ? 'Je ne sais pas si mon besoin de collecte est ponctuel ou récurrent'
      : values.besoinType

  const accompagnementType =
    values.accompagnementType.length > 0
      ? `Type(s) d'accompagnement(s): ${values.accompagnementType.join('; ')}`
      : ''

  if (values.siteType === 'perimeter') {
    const hydrateAdresse = values.address.value.split(';')
    const [
      etsPresteAdresseD,
      etsPresteCodeD,
      etsPresteVilleD,
      numDebiteur,
    ] = hydrateAdresse

    siteType = 'Ma demande concerne une adresse existante'
    etsPresteAdresse = etsPresteAdresseD
    etsPresteCode = etsPresteCodeD
    etsPresteVille = etsPresteVilleD
    numDebiteurBenif = numDebiteur
    idEtablissementBenif = values.address.idEntreprise
  } else {
    siteType = 'Ma demande concerne une nouvelle adresse'
    etsPresteAdresse = values.address
    etsPresteCode = values.cpcode
    etsPresteVille = values.city
    numDebiteurBenif = values.numDebiteurAttachement
    idEtablissementBenif = values.idEntrepriseAttachement
  }

  const firstSection = `
      Raison sociale : ${values.company}
      Nom du bénéficiaire : ${values.lastName}
      Prénom du bénéficiaire : ${values.firstName}
      Téléphone mobile du bénéficiaire : ${values.mobilePhone}
      Téléphone fixe du bénéficiaire : ${values.officePhone}
      Adresse email du bénéficiaire : ${values.email}
      Fonction du bénéficiaire : ${values.fonction}
      Numéro client : ${numDebiteurBenif}`

  const secondSection = `${siteType}
      Adresse du site : ${etsPresteAdresse}
      Code postal : ${etsPresteCode}
      Ville : ${etsPresteVille}
      ${values.numberOfSites} ${nbrSites}
      Date souhaitée : ${moment(values.planifiedDate)?.format('DD/MM/YYYY')}
      ${typeWaste}
      ${doYouHave}
      ${accompagnementType}
      `.replace(/^\s*[\r\n]/gm, '')

  const thirdSection = `-------------------------------------------------------------

      Commentaire : ${values.comment}`

  const descriptionWithContainer = `
      ${firstSection}

      -------------------------------------------------------------

      ${secondSection}
      ${values.comment !== '' ? thirdSection : ''}
    `
  return [
    etsPresteAdresse,
    etsPresteCode,
    etsPresteVille,
    planifiedDate,
    descriptionWithContainer,
    numDebiteurBenif,
    idEtablissementBenif,
  ]
}

// Correspondance Tri du tableau de la liste des demandes
const labelsToApiFields: { [key: string]: string } = {
  'N° demande': 'OrdreNumeroDemande',
  'Créé le': 'OrdreDateCreationDemande',
  Statut: 'OrdreStatut',
}

export async function getEceDemands(
  organisations: OrganizationEntity[] = [],
  institutions: InstitutionEntity[] = [],
  estDemandeSupport = false
): Promise<{
  results: DemandEntity[]
  totalItems: number
  isTimeOut: boolean
}> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/demands`
  const params = new URLSearchParams()

  organisations.forEach((orga) => {
    params.append(`idOrganisation[]`, orga.id)
  })
  institutions.forEach((insti) => {
    params.append(`idEtablissement[]`, insti.id)
  })

  params.append('estDemandeSupport', estDemandeSupport.toString())

  if (cancelTokenProgress !== undefined) {
    cancelTokenProgress.cancel('Operation canceled due to new request.')
  }

  cancelTokenProgress = axios.CancelToken.source()

  try {
    const resp = await axios({
      method: 'GET',
      url,
      params,
      cancelToken: cancelTokenProgress.token,
      timeout: TIME_OUT_TABLE,
    })
    const data = getMemberData(resp.data)
    const results = DemandNormalizer.normalize(data)
    const totalItems = getTotalItems(resp.data)
    return { results, totalItems, isTimeOut: false }
  } catch (err) {
    if (err?.code === 'ECONNABORTED') {
      return Promise.resolve({
        results: [],
        totalItems: 0,
        isTimeOut: true,
      })
    }
    if (isCancel(err)) {
      return Promise.resolve({ results: err, totalItems: 0, isTimeOut: false })
    }
    console.error(err)
    throw new Error(`Erreur lors de l'appel api : lister les demandes`)
  }
}

export async function getListeDemands(
  transcoMotifs: MotifTransco[],
  organisations: OrganizationEntity[] = [],
  institutions: InstitutionEntity[] = [],
  perPage: number,
  page: number,
  sortTable: any,
  filtres: { [key: string]: any | any[] },
  estDemandeSupport = false,
  allDemands: boolean,
  cancelTokenDemand: CancelTokenSource
): Promise<{
  results: DemandEntity[]
  totalItems: number
  isTimeOut: boolean
}> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/demands/wdh`
  const params = new URLSearchParams({
    NumeroPage: String(page),
    NombreDemandeParPage: String(perPage),
  })

  organisations.forEach((orga) => {
    params.append(`IdOrganisation[]`, orga.id)
  })

  institutions.forEach((insti) => {
    params.append(`IdEtablissementClientWDH[]`, insti.id)
  })

  if (sortTable) {
    Object.keys(sortTable).forEach((key: string) => {
      params.append(labelsToApiFields[key], sortTable[key])
    })
  }

  if (Object.keys(filtres).length > 0) {
    if (filtres.numDemand !== '' && filtres.numDemand !== undefined)
      params.append('Numerodemande', filtres.numDemand)

    if (
      filtres.status?.value !== 'All' &&
      filtres.status?.value !== undefined
    ) {
      params.append('Statut', filtres.status.value)
    }

    if (filtres.period?.startDate != null)
      params.append(
        'DateCreationDemandeApresLe',
        formatToInputDateWDH(filtres.period.startDate, 'DD/MM/YYYY')
      )

    if (filtres.period?.endDate != null)
      params.append(
        'DateCreationDemandeAvantLe',
        formatToInputDateWDH(filtres.period.endDate, 'DD/MM/YYYY')
      )

    if (filtres.motif?.length > 0) {
      const motifIds = filtres.motif.map(
        (item: { label: string; value: string }) => item.value
      )
      const convertedMotifs = convertMotifFromEceToCcap(transcoMotifs, motifIds)
      convertedMotifs.forEach((motif) => {
        params.append('TypeMotifDetail[]', motif)
      })
    }

    if (filtres.site?.length > 0) {
      filtres.site.forEach((site: any) => {
        params.append('SitePrestation[]', site)
      })
    }

    filtres.libelleDechet?.forEach((dechet: any) => {
      params.append('TypeDechet[]', dechet)
    })

    filtres.contenant?.forEach((materiel: any) => {
      params.append('Materiel[]', materiel)
    })

    filtres.numDossierErp?.forEach((numDossier: any) => {
      params.append('NumDossier[]', numDossier)
    })
  }

  params.append(`DemandeSupport`, estDemandeSupport.toString())
  if (!estDemandeSupport) params.append(`allDemands`, allDemands.toString())

  try {
    const resp = await axios({
      method: 'GET',
      url,
      params,
      cancelToken: cancelTokenDemand.token,
      timeout: TIME_OUT_TABLE,
    })

    const data = resp.data.listeDemandes
    const results = DemandNormalizer.normalizeWDH(data)
    const totalItems = resp.data.totalDemandes
    return { results, totalItems, isTimeOut: false }
  } catch (err) {
    if (err?.code === 'ECONNABORTED') {
      return Promise.resolve({
        results: [],
        totalItems: 0,
        isTimeOut: true,
      })
    }

    if (isCancel(err)) {
      return Promise.resolve({
        results: [],
        totalItems: 0,
        isTimeOut: false,
      })
    }
    console.error(err)
    throw new Error(`Erreur lors de l'appel api WDH : lister les demandes`)
  }
}

export async function getDemandDetail(id: string): Promise<DemandDetailEntity> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/demands/${id}`
  try {
    const resp = await axios({
      method: 'GET',
      url,
    })

    return resp?.data
      ? DemandDetailNormalizer.normalize(resp.data)
      : Promise.reject()
  } catch (err) {
    console.error(err)
    if (err?.response?.status === 404) {
      throw TypeError('NotFound')
    }
    throw TypeError('Error while fetching demand detail API')
  }
}

export async function getListStatus(): Promise<{
  statusOptions: DemandStatusOptions[]
}> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/demand_statuts`

  try {
    const resp = await axios({
      method: 'GET',
      url,
    })
    const data = getMemberData(resp.data)
    return DemandNormalizer.normalizeStatus(data)
  } catch (err) {
    console.log(err)
    throw new Error(`Erreur lors de l'appel api : lister les statuts demandes`)
  }
}

export async function getDemandFile(
  idPJCCAP: string | undefined
): Promise<Blob> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/demands/wdh/file/${idPJCCAP}`
  try {
    const resp = await axios({
      responseType: 'blob', // Set the responseType to 'blob'
      method: 'GET',
      url,
    })

    return resp?.data as Blob
  } catch (err) {
    console.log(err)
    throw new Error(`
    Erreur lors de l'appel de l'api de récupération de pièce jointe ${idPJCCAP}.
  `)
  }
}

export async function createDemandComment(
  id: string | undefined,
  content: string,
  action: string,
  closedDate?: string | undefined
): Promise<ICommentPostResponse> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/demands/${id}/comment`
  try {
    const resp = await axios({
      method: 'POST',
      url,
      data: {
        content,
        action,
        closedDate,
      },
    })
    return resp.data
  } catch (err) {
    console.log(err)
    throw new Error(`Erreur lors de l'appel de l'api d'ajout d'un commentaire.`)
  }
}
export const donwloadFile = async (
  idPJCCAP: string | undefined,
  fileName: string
) => {
  try {
    const data = await getDemandFile(idPJCCAP)
    const url = URL.createObjectURL(data)
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    a.click()
    // Clean up the Blob URL after the download is triggered
    URL.revokeObjectURL(url)
    return true
  } catch (error) {
    return false
  }
}

export async function createDemandFile(
  id: string | undefined,
  formData: FormData
): Promise<IFilePostResponse> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/demands/${id}/file`
  try {
    const resp = await axios({
      method: 'POST',
      url,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return resp.data
  } catch (err) {
    console.log(err)
    throw new Error(
      `Erreur lors de l'appel de l'api d'ajout d'une pièce jointe.`
    )
  }
}

export const decodeFileData = (fileBase64: string = '', fileName: string) => {
  const byteCharacters = atob(fileBase64)

  const byteNumbers = new Array(byteCharacters.length)
  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }

  const byteArray = new Uint8Array(byteNumbers)
  const blob = new Blob([byteArray])
  const blobUrl = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = blobUrl
  a.download = fileName
  a.click()

  // Clean up the Blob URL after the download is triggered
  URL.revokeObjectURL(blobUrl)
}
